// src/mocks/handlers/customer/index.ts

import { customerDeleteUserHandler } from './customerDeleteUserHandler';
import { customerNewUserHandler } from './customerNewUserHandler';
import { customerResendInviteHandler } from './customerResendInviteHandler';
import { customerUpdateUserHandler } from './customerUpdateUserHandler';
import { customerUsersHandler } from './customerUsersHandler';

export const customerHandlers = [
  customerUsersHandler,
  customerUpdateUserHandler,
  customerDeleteUserHandler,
  customerNewUserHandler,
  customerResendInviteHandler,
];
